import { Component, Input, OnInit, NgZone, Output, EventEmitter } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Configuration } from "../core/configuration";
import { Content } from "../core/models/content";
import { Option } from "../core/models/options-content";
import { TextContent } from "../core/models/text-content";
import { ConfigurationLoader } from "../core/services/configuration-loader.service";

/**
 * Componente responsável pela exibição de um conteúdo do tipo Texto.
 */
@Component({
    selector: "serprobots-message-text-content",
    templateUrl: "text-content.component.html"
})
export class TextContentComponent implements OnInit {

    text!: SafeHtml;

    @Input() content: Content = new TextContent("");
    configuration: Configuration = new Configuration({});

    // Evento que é emitido toda vez que a função "sendOptionMessage()" em Javascript
    // for invocada através de elementos HTML embutidos na mensagem.
    @Output() requestSendOption = new EventEmitter<Option>();

    // Evento que é emitido toda vez que a função "sendTextMessage()" em Javascript
    // for invocada através de elementos HTML embutidos na mensagem.
    @Output() requestSendText = new EventEmitter<string>();

    constructor(
        private ngZone: NgZone,
        private sanetize: DomSanitizer,
        private configurationLoader: ConfigurationLoader
    ) {}

    async ngOnInit(): Promise<void> {
        this.configuration = await this.configurationLoader.getConfiguration();
        let text = (this.content as TextContent).text;
        if (/<[^>]+>/g.test(text)) {
          // Se o texto contém tags HTML, substitui duas ou mais quebras de linha consecutivas por <br>
          text = text.replace(/(?:\r\n|\r|\n){2,}/g, '<br>');
        } else {
          // Se o texto não contém tags HTML, substitui todas as quebras de linha por <br>
          text = text.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }

        this.text = this.sanetize.bypassSecurityTrustHtml(text);

        // Disponibilizamos uma função que pode ser chamada a partir de tags HTML contidas na resposta do componente/bot.
        // Por exemplo, um componente Rivescript pode formatar uma resposta usando links com a tag <a> e usar o evento "onclick"
        // para realizar o envio de uma mensagem quando este link for clicado.

        // Criamos um namespace chamado "serprobots" para evitar possíveis conflitos com outras bibliotecas.
        (<any>window).serprobots = {};

        // Disponibilizamos a função window.serprobots.sendOptionMessage() para que seja usada nas tags HTML contidas na resposta.
        (<any>window).serprobots.sendOptionMessage = this.ngZoneSendOptionMessage.bind(this);

        // Disponibilizamos a função window.serprobots.sendTextMessage() para que seja usada nas tags HTML contidas na resposta.
        (<any>window).serprobots.sendTextMessage = this.ngZoneSendTextMessage.bind(this);
    }

    /**
     * Executa a função Javascript que está disponibilizada globalmente no objeto window
     * dentro da Zone.
     *
     * @param label Label que será exibido na tela do chatbot.
     * @param value Valor que será enviado para o Gateway.
     */
     ngZoneSendTextMessage(text: string): void {
        this.ngZone.run(() => this.sendTextMessage(text));
    }

    /**
     * Executa a função Javascript que está disponibilizada globalmente no objeto window
     * dentro da Zone.
     *
     * @param label Label que será exibido na tela do chatbot.
     * @param value Valor que será enviado para o Gateway.
     */
    ngZoneSendOptionMessage(label: string, value: string): void {
        this.ngZone.run(() => this.sendOptionMessage(label, value));
    }

    /**
     * Dispara o evento que solicita aos componentes que forem "listeners" para enviarem uma mensagem do tipo option.
     *
     * @param label Label a ser enviado.
     * @param value Value a ser enviado.
     */
    sendOptionMessage(label: string, value: string): void {
        this.requestSendOption.emit(new Option(label, value, false));
    }

    /**
     * Dispara o evento que solicita aos componentes que forem "listeners" para enviarem uma mensagem do tipo text.
     *
     * @param text Texto a ser enviado para o Gateway.
     */
    sendTextMessage(text: string): void {
        this.requestSendText.emit(text);
    }

}
